import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getAllMagnetNotifications } from "apis/notification";
import { get } from "utils/request";
import Loading from "components/atoms/Loading";
import { useRouter } from "components/hooks";
import UserAndMagnetActivityCard from "components/atoms/cards/user/UserAndMagnetActivityCard";
import { useUserContext } from "components/context/UserContext";
import { TOAST_CONFIG } from "../../constants";
import { PollEmptyState } from "./EmptyStates";

const POLL_TYPE_NOTIFICATIONS = [
  "POLL",
  "POLL_RESPONDED",
  "POLL_STARTED",
  "SOCIAL_SHARE_SCHEDULED",
  "SOCIAL_SHARE_AVAILABLE",
  "SOCIAL_SHARE_STARTED",
];
function MagnetInteractions({ isCustomizedUIBrand = false }: { isCustomizedUIBrand?: boolean }) {
  const { isUserLoggedIn } = useUserContext();
  const handleGetAllMagnetNotificationsError = (errorMessage: string) => {
    toast.error(errorMessage, TOAST_CONFIG);
  };

  const router = useRouter();

  const { magnetId } = router.query;

  const {
    isLoading,
    data: allMagnetNotificationsData,
    error,
    isFetching,
  } = useQuery({
    refetchInterval: 5000,
    enabled: isUserLoggedIn,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["magnet-notifications", magnetId],
    queryFn: () =>
      get(getAllMagnetNotifications(magnetId), {
        processError: handleGetAllMagnetNotificationsError,
      }),
  });

  if (isLoading && isFetching) return <Loading />;

  if (error) return <p>Something went wrong</p>;

  const magnetNotificationsToDisplay = allMagnetNotificationsData?.results?.filter((activity: MagnetAndUserActivity) =>
    POLL_TYPE_NOTIFICATIONS.includes(activity.sub_type),
  );

  return (
    <div className="secondary-scrollbar flex flex-1 flex-col gap-y-2 overflow-y-auto lg:gap-y-1 lg:p-4 lg:px-2 lg:pt-0 2xl:gap-y-2 2xl:p-6">
      {magnetNotificationsToDisplay?.length ? (
        magnetNotificationsToDisplay.map((interactions: MagnetAndUserActivity) => (
          <div className="relative" key={`UserMagnetNotification${interactions.id}`}>
            <UserAndMagnetActivityCard
              textDark={isCustomizedUIBrand}
              key={`magnet-interactions${interactions.id}`}
              // @ts-ignore
              imageUrl={interactions.image_url}
              createdAt={interactions.created_at}
              description={interactions.description}
              navigationLink={interactions.cta}
              actionType={interactions.action_type}
              subType={interactions.sub_type}
              iconUrl={interactions.icon_url}
              additionalClasses="!border-white"
            />
          </div>
        ))
      ) : (
        <PollEmptyState isDark={isCustomizedUIBrand} />
      )}
    </div>
  );
}
export default MagnetInteractions;
